// Whole-burst tournament: every original participates; persist only the final winner.
export const COMPARISON_VERSION = "burst-winner-v2";
export const photoIdentity = (p) => JSON.stringify([p.file?.webkitRelativePath || p.relativePath || p.name, p.size || p.file?.size || 0, p.file?.lastModified || p.lastModified || 0]);
export const groupIdentity = (photos) => JSON.stringify(photos.map(photoIdentity).sort());
export function completedComparison(photos) {
  const group = groupIdentity(photos);
  const c = photos[0]?.selectionComparison;
  return !!c && c.version === COMPARISON_VERSION && c.group === group && photos.every(p => p.selectionComparison?.version === COMPARISON_VERSION && p.selectionComparison?.group_size === photos.length && p.selectionComparison?.group === group && p.selectionComparison?.winner === c.winner) && photos.filter(p => p.selectedForEdit).length === 1 && photos.some(p => p.selectedForEdit && photoIdentity(p) === c.winner);
}
export async function compareWholeBurst(photos, compare, checkAlive = () => {}) {
  if (photos.length < 2) throw new Error("Se necesitan al menos dos fotos");
  let round = [...photos], reason = "", reserves = [];
  while (round.length > 1) {
    const winners = [];
    for (let i = 0; i < round.length; i += 8) {
      checkAlive();
      const batch = round.slice(i, i + 8);
      if (batch.length === 1) { winners.push(batch[0]); continue; }
      const result = await compare(batch);
      checkAlive();
      const winner = batch.find(p => p.id === result?.winnerId);
      if (!winner || typeof result?.reason !== "string" || !result.reason.trim()) throw new Error("Comparación inválida: no se cambia la selección");
      winners.push(winner);
      reason = result.reason;
      reserves = round.length <= 8 ? batch.filter(p => p !== winner && (result.reserveIds || []).includes(p.id)).slice(0, 2) : [];
    }
    round = winners;
  }
  return { winner: round[0], comparison: { version: COMPARISON_VERSION, group: groupIdentity(photos), winner: photoIdentity(round[0]), group_size: photos.length, reason, reserves: reserves.map(photoIdentity) } };
}
export function applyComparison(all, members, result) {
  const ids = new Set(members.map(p => p.id));
  const reserves = new Set(result.comparison.reserves || []);
  return all.map(p => ids.has(p.id) ? {...p, selectedForEdit: p.id === result.winner.id, isBest: p.id === result.winner.id, isReserve: p.id !== result.winner.id && reserves.has(photoIdentity(p)), source: "ai", selectionComparison: result.comparison} : p);
}
// Agrupa ráfagas contiguas de ≤max fotos en una misma consulta; las grandes van solas (eliminatorias).
export function planUnits(bursts, max = 8) {
  const units = [];
  let pack = [], size = 0;
  const flush = () => { if (pack.length) units.push(pack); pack = []; size = 0; };
  for (const b of bursts) {
    if (b.photos.length > max) { flush(); units.push([b]); continue; }
    if (size + b.photos.length > max) flush();
    pack.push(b); size += b.photos.length;
  }
  flush();
  return units;
}
// Errores que hacen inútil seguir con otras ráfagas (pausa, proveedor saturado o sin saldo).
export function isFatalSelectionError(err, aborted) {
  if (aborted || err?.fatal) return true;
  const msg = String(err?.response?.data?.detail || err?.message || "");
  return err?.response?.status === 429 || err?.response?.status === 401 || err?.response?.status === 402 || /quota|credit|billing|insufficient|cuota|saldo|pausada/i.test(msg);
}
